module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av391-d8eb4e6a7dd2ebefd4e6227cff6670b5.jpg";